import { reactive } from 'vue'

import { logError } from '@/logger'
import { OlympusClient } from '@/OlympusClient'

interface CateringDestinations {
  cateringUrl: string | null
  cateringMenuUrl: string | null
}

const cache = reactive<Record<string, CateringDestinations | null>>({})

export const getBrandCateringDestinations = (
  brandId: string | undefined
): CateringDestinations | null | undefined =>
  brandId ? cache[brandId] : undefined

export const loadBrandCateringDestinations = async (
  brandId: string
): Promise<void> => {
  try {
    const context =
      await OlympusClient.marketing.v2.brands.brand.getBrandContext({
        params: { brandId },
        query: {},
      })
    cache[brandId] = {
      cateringMenuUrl: context.cateringMenuUrl,
      cateringUrl: context.cateringUrl,
    }
  } catch (error) {
    cache[brandId] = null
    logError(error, {
      brandId,
      feature: 'custom-campaign-catering-destinations',
    })
  }
}
